import { CSSProperties, PropsWithChildren } from 'react';
import styles from '../../styles/Buttons.module.css'

export enum ButtonColors {
  Blue = 1,
  White = 2,
  Grey = 3,
  Green = 4,
  Red = 5,
}

export enum ButtonSizes {
  Small = 1,
  Standard = 2,
  Large = 3,
  ExtraSmall = 4,
}

export enum ButtonShapes {
  Rectangle = 1,
  Rounded = 2,
}

export enum ButtonBorder {
  Blue = 1,
  White = 2,
}

//TODO: update Safekey button, remove buttonText prop, only use children
export interface ISafeKeyButtonProps {
  buttonText?: string;
  buttonColor?: ButtonColors;
  buttonSize?: ButtonSizes;
  buttonShape?: ButtonShapes;
  buttonBorder?: ButtonBorder;
  onClick: () => void;
  hintText?: string;
  disabled?: boolean;
  style?: CSSProperties;
}

/**
 * Button component with styles controlled by enums for color, size, and type.
 * @param param0 
 * @returns 
 */
export const SafeKeyButton: React.FC<PropsWithChildren<ISafeKeyButtonProps>> = ({ buttonText, buttonColor, buttonSize, buttonShape, buttonBorder, onClick, children, style, hintText = '', disabled = false }) => {
  let buttonStyle: string;
  switch (buttonColor) {
    case ButtonColors.Blue:
      buttonStyle = styles.blueButton;
      break;
    case ButtonColors.White:
      buttonStyle = styles.whiteButton;
      break;
    case ButtonColors.Grey:
      buttonStyle = styles.greyButton;
      break;
    case ButtonColors.Green:
      buttonStyle = styles.greenButton;
      break;
    case ButtonColors.Red:
      buttonStyle = styles.redButton;
      break;
    default:
      buttonStyle = styles.blueButton;
      break;
  }
  if (buttonSize)
    switch (buttonSize) {
      case ButtonSizes.Standard:
        break;
      case ButtonSizes.Small:
        buttonStyle += ` ${styles.smallButton}`;
        break;
      case ButtonSizes.Large:
        buttonStyle += ` ${styles.largeButton}`;
        break;
      case ButtonSizes.ExtraSmall:
        buttonStyle += ` ${styles.extraSmallButton}`;
        break;
      default:
        break;
    }
  if (buttonShape)
    switch (buttonShape) {
      case ButtonShapes.Rounded:
        buttonStyle += ` ${styles.roundedButton}`;
        break;
      case ButtonShapes.Rectangle:
        break;
      default:
        break;
    }
  if (buttonBorder)
    switch (buttonBorder) {
      case ButtonBorder.Blue:
        buttonStyle += ` ${styles.blueBorder}`;
        break;
      case ButtonBorder.White:
        buttonStyle += ` ${styles.whiteBorder}`;
        break;
      default:
        break;
    }

  return (
    <button className={`${styles.safeKeyButton} ${buttonStyle}`} 
      onClick={disabled ? () => {} : onClick} 
      disabled={disabled} 
      title={hintText}
      style={style ? style : {}}>
      {buttonText ? buttonText : children}
    </button>
  );
}